import getOrdinalForNumber from "@/utils/numbers/getOrdinalForNumber";

export const getGradesText = (grades: number[], abbreviated = false) => {
  return grades.reduce((acc: string, grade: number, index: number) => {
    let ordinal;

    switch (grade) {
      case 0:
        ordinal = abbreviated ? "K" : "Kindergarten";
        break;
      default:
        ordinal = abbreviated ? `${grade}` : getOrdinalForNumber(grade);
    }

    const isLastItem = grades.length === index + 1;
    const gradeString = !abbreviated
      ? `${grades.length === 1 ? " grade" : " grades"}`
      : "";
    const gradeStringCondition =
      `${grade !== 0 && !abbreviated ? grade : ""}${ordinal}` +
      `${isLastItem ? gradeString : ", "}`;

    if (!acc) {
      acc = gradeStringCondition;
    } else {
      acc = acc + gradeStringCondition;
    }
    return acc;
  }, "");
};
